import { useSelector } from 'react-redux'
import { RootState } from 'store'

export const LogoutIcon = () => {
    const { darkMode } = useSelector((store: RootState) => store.globals)
    const stroke = !darkMode ? '#464255' : '#fff'
    return <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.75 15.625H2.58333C2.16341 15.625 1.76068 15.4582 1.46375 15.1613C1.16681 14.8643 1 14.4616 1 14.0417V2.95833C1 2.53841 1.16681 2.13568 1.46375 1.83875C1.76068 1.54181 2.16341 1.375 2.58333 1.375H5.75" stroke={stroke} strokeWidth="1.58333" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M11.293 12.4584L15.2513 8.50008L11.293 4.54175" stroke={stroke} strokeWidth="1.58333" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M15.25 8.5H5.75" stroke={stroke} strokeWidth="1.58333" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

}